import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import ModalAlertWarning from "../modalAlertWarning";
import { MODALS } from "../../../../config/images";
import { validateImageFile } from "../../../../utils/imageValidation";
import { useBrokenImages } from "../../../../hooks/useBrokenImages";
import NewsImagePlaceholder from "../../newsImagePlaceholder";
const EditNewsModal = ({ 
  isOpen, 
  onClose, 
  image, 
  title, 
  description,
  date,
  onImageChange,
  onTitleChange,
  onDescriptionChange,
  onSave,
  newsId
}) => {

  const navigate = useNavigate();
  const [selectedImageFile, setSelectedImageFile] = useState(null); 
  const [characterCount, setCharacterCount] = useState(title?.length || 0);
  const [showAlert, setShowAlert] = useState(false); 
  const [alertMessage, setAlertMessage] = useState(""); 
  const { hasImage, markBroken } = useBrokenImages();


const handleImageChangeInternal = async (e) => {
  const input = e.target;
  const file = input.files?.[0];
  if (!file) return;

  const { isValid, message } = await validateImageFile(file);
  if (!isValid) {
    setAlertMessage(message);
    setShowAlert(true);
    input.value = '';
    return;
  }

  const imageUrl = URL.createObjectURL(file);
  setSelectedImageFile(file);
  onImageChange(imageUrl, file);
};

  const handleTitleChangeInternal = (e) => {
    const input = e.target.value;
    if (input.length <= 50) {
      onTitleChange(input);
      setCharacterCount(input.length);
    }
  };

  const handleConfirm = () => {
    if (title.length > 50) {
      setAlertMessage("El título no puede exceder los 50 caracteres.");
      setShowAlert(true);
      return;
    }
    onSave();
    navigate(`/actualizar-noticia/${newsId}`, {
      state: {
        editedTitle: title,
        editedDescription: description,
        editedImage: image,
        editedImageFile: selectedImageFile
      }
    });
  };


  if (!isOpen) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };
  


  return (
<>
      <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
        <div className="lg:w-[33.33%] sm:w-[50%] w-[95%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4">
          <div className='flex justify-end'>
            <button onClick={onClose} className="px-4 py-2 rounded-md">
              <img src={MODALS.CLOSE} alt="cerrar"/>
            </button>
          </div>
  
          <div className="flex items-center justify-center w-full">
            <div className="flex flex-col items-center justify-center gap-2 w-[267px] py-6">
              <div className="relative flex items-center justify-center w-full ">
                <div className={`relative flex flex-col items-center justify-center w-[267px] h-[185px] bg-white ${
                  hasImage(image) ? '' : 'border border-[#6B7280] border-dashed rounded-2xl'
                }`}>
                  {hasImage(image) ? (
                    <>
                      <img 
                        src={image} 
                        alt="Imagen Noticias" 
                        onError={() => markBroken(image)}
                        className="object-fill w-[267px] rounded-2xl h-[185px] "
                      />
                      <label className="absolute flex items-center justify-center p-2 text-white rounded-full cursor-pointer bottom-2 right-2 bg-blue">
    
                        <input
                          type="file"
                          onChange={handleImageChangeInternal}
                          className="hidden"
                          accept=".jpg,.jpeg,.png,.webp,.svg"
                        />
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                        </svg>
                        </label>
                    </>
                  ) : (
                    <NewsImagePlaceholder onChange={handleImageChangeInternal} />
                  )}
                </div>
              </div>
    
                <input
                  type="text"
                  value={title}
                  onChange={handleTitleChangeInternal}
                  maxLength={50}
                  className="font-itcmedium outline-none w-full text-[20px] border-b border-gray-200 text-[#21243D]"
                />
    
                <textarea
                  value={description}
                  onChange={(e) => onDescriptionChange(e.target.value)}
                  className="w-full font-itcbook text-xs text-[#1A202C] outline-none  border-b border-gray-200 h-20"
                />
    
                <div className="flex items-center justify-between w-full">
                    <p className="text-white font-itcmedium text-[10px] w-[72px] h-[25px] bg-[#EFB86A] rounded-lg py-[6px] px-4">Noticias</p>
                    <p className="bg-[#BBBFCC] text-[#414141] font-itcmedium flex items-center justify-center w-[95px] h-[25px] text-[10px] py-[6px] px-4 rounded-lg">{formatDate(date)}</p>
                </div>
    
              <button
                onClick={handleConfirm}
                className="px-4 py-2 underline font-itcbook text-[15px] text-blue"
              >
                Confirmar 
              </button>
            </div>
          </div>
        </div>
      </div>
      <ModalAlertWarning
        showModalAlertWarning={showAlert}
        closeModal={() => setShowAlert(false)}
        error={alertMessage}
        accept={() => setShowAlert(false)}
      />
</>
  );
};

export default EditNewsModal;